/**
 * Backbone Singleton
 * @link https://github.com/reconbot/backbone-singleton
 */

const Backbone = require('backbone');
const _ = require('underscore');

const Model = Backbone.Model;

const SingletonModel = function() {
  const model = this.capture.apply(this, arguments);
  return model || Model.apply(this, arguments);
};

SingletonModel.prototype = Model.prototype;

SingletonModel.prototype._singleton = {
  store: {},
  counts: {}
};

SingletonModel.prototype.hash = function(attr) {
  attr = attr || {};
  const idAttr = this.idAttribute || 'id';
  return this.id || attr[idAttr];
};

SingletonModel.prototype.capture = function() {
  const meta = this._singleton;

  const hash = this.hash.apply(this, arguments);
  if (typeof hash === 'undefined') {
    this.singleton = false;
    return;
  }

  const model = meta.store[hash];
  if (model === this) {
    return this;
  }

  if (model) {
    meta.counts[hash]++;
    model.set(...arguments);
    return model;
  }

  meta.store[hash] = this;
  meta.counts[hash] = 1;
  this.singleton = true;
};

SingletonModel.prototype.release = function() {
  if (!this.singleton) {
    return;
  }
  const meta = this._singleton;
  const hash = this.hash();
  meta.counts[hash]--;
};

// Class methods
_.extend(SingletonModel, Model);

SingletonModel.extend = function(protoProps, staticProps) {
  const parent = this;
  const constructor = function() {
    return parent.apply(this, arguments);
  };

  if (_.isObject(protoProps)) {
    protoProps.constructor = constructor;
  } else {
    protoProps = { constructor };
  }

  const child = Model.extend.call(this, protoProps, staticProps);
  child.prototype._singleton = {
    store: {},
    counts: {}
  };
  return child;
};

SingletonModel.reap = function() {
  // delete all models with counts === 0;
  const meta = this.prototype._singleton;
  _.forEach(meta.counts, (count, hash) => {
    if (count < 1) {
      delete meta.store[hash];
      delete meta.counts[hash];
    }
  });
};

module.exports = SingletonModel;



// WEBPACK FOOTER //
// ./src/extensions/singleton-model.js